import { render } from "./humanityLibraryManage.vue?vue&type=template&id=ddd13428&scoped=true"
import script from "./humanityLibraryManage.vue?vue&type=script&lang=js"
export * from "./humanityLibraryManage.vue?vue&type=script&lang=js"

import "./humanityLibraryManage.vue?vue&type=style&index=0&id=ddd13428&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd13428"]])

export default __exports__